import { Box } from '@mui/material'
import React from 'react'

export default function OurLocation() {
  return (
    <>
         <Box className="container-fluid py-3" sx={{p:0, m:0}}>
          <div className="row">
            
            <div >
            
              <iframe
              className="w-100"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14009.282319751126!2d77.36034465!3d28.62015255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5456ef36d9f%3A0x3b7191b1286136c8!2sSector%2062%2C%20Noida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1687161471764!5m2!1sen!2sin" 
              width="100%" 
              height="600"            
              allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          
          </div>
        </Box>
    </>
  )
}
